import Home from './views'
import PageNotFound from './views/404'
import Maintenance from './views/maintenance'
import OrderStatus from './views/order/[id]/success'
import DownloadAuth from './views/order/download/download-auth'
import DownloadETours from './views/order/download/download-etours'
 
export const DOWNLOAD_AUTH = "/download/auth/";
export const DOWNLOAD_ETOURS = "/download/";
 

const buildRoutes = (): any[] => {
  const routes = window.environment?.isMaintenance === true
    ? [
      { path: '*', component: Maintenance },
    ]
    : [
      { path: '/', component: Home, exact: true },
      { path: DOWNLOAD_AUTH + ':disseminationKey', component: DownloadAuth, exact: true },
      { path: DOWNLOAD_ETOURS + ':disseminationKey', component: DownloadETours, exact: true },
      { path: '/order/:id', component: OrderStatus, exact: true },
      { path: '*', component: PageNotFound },
    ]
  return routes;
};

export default buildRoutes
